import FormGridItem from '~/components/FormComponents/FormGridItem.tsx';
import { FormInput } from '~/components/FormComponents/FormInput.tsx';
import { Box, Grid, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { selectGeneralInfoFullNameUkr } from '~/store/identification-form/selectors.ts';
import { useFormContext, useWatch } from 'react-hook-form';
import { useEffect } from 'react';
import {
  FatcaStatusFFI,
  FatcaStatusFFIOptions,
  shuwGiinFatcaStatusFFI,
} from '~/modules/identification/forms/FatcaAdditionalInformation/constants/constants.ts';
import { MultilineTextInput } from '~/components/TextField/MultilineTextInput.tsx';
import { commonStyles } from '~/theme/styles/commonStyles.ts';
import { InfoTooltip } from '~/components/InfoTooltip/InfoTooltip.tsx';
import { FormRadioGroup } from '~/components/FormComponents/FormRadioGroup.tsx';
import { informerForeignFinancialInstitutionInfo } from '~/modules/identification/forms/FatcaAdditionalInformation/constants/informers.tsx';

export const ForeignFinancialInstitutionInfo = () => {
  const { setValue, control } = useFormContext();
  const fullNameUkr = useSelector(selectGeneralInfoFullNameUkr) || {};
  const basePath = `foreignFinancialInstitutionInfo`;

  const [fatcaStatusFFI] = useWatch({
    name: [`${basePath}.fatcaStatusFFI`],
    control,
  });

  useEffect(() => {
    if (fullNameUkr) {
      setValue(`${basePath}.clientFullName`, fullNameUkr);
    }
  }, [fullNameUkr]);

  return (
    <Grid container spacing={3}>
      <FormGridItem>
        <FormInput
          name={`${basePath}.clientFullName`}
          label="Повне найменування юридичної особи"
          placeholder="Введіть повне найменування юридичної особи"
          disabled
          fullWidth
        />
      </FormGridItem>
      <FormRadioGroup
        name={`${basePath}.fatcaStatusFFI`}
        options={FatcaStatusFFIOptions}
        label={
          <Box sx={{ ...commonStyles.centerFlexContainer, gap: 1 }}>
            <Typography variant="body2">
              Вкажіть, будь ласка, FATCA-статус Вашої установи та номер GIIN
            </Typography>
            <InfoTooltip title={informerForeignFinancialInstitutionInfo} />
          </Box>
        }
      />
      {shuwGiinFatcaStatusFFI.includes(fatcaStatusFFI) && (
        <FormInput
          name={`${basePath}.giin`}
          label="Ідентифікаційний номер посередника (GIIN) Власника Рахунку"
          placeholder="Введіть ідентифікаційний номер посередника (GIIN) Власника Рахунку"
          fullWidth
        />
      )}
      {fatcaStatusFFI === FatcaStatusFFI.OTHER && (
        <MultilineTextInput
          name={`${basePath}.otherFatcaStatusFFI`}
          label={'Інший FATCA-статус FFI'}
          placeholder="Вкажіть інший FATCA-статус FFI"
          textSize={500}
        />
      )}
    </Grid>
  );
};
